import React from "react";
import { Link } from "react-router-dom";
import CategoryIcon from "../illustrations/CategoryIcon";
import { findCategory, photoAlt } from "../data/menu";

export function VegMark({ veg }) {
  return (
    <span className={`ro-veg ${veg ? "ro-veg--veg" : "ro-veg--nonveg"}`}>
      <span aria-hidden="true" />
      {veg ? "Veg" : "Non-veg"}
    </span>
  );
}

export default function MenuItemCard({ item }) {
  const cat = findCategory(item.categorySlug);
  return (
    <Link to={`/menu/item/${item.id}`} className="ro-item-card" style={{ "--ro-theme": item.colour, "--ro-pale": item.pale }}>
      <div className="ro-item-card__tile">
        {item.photo ? (
          <img src={item.photo} alt={photoAlt(item)} loading="lazy" />
        ) : (
          <span className="ro-item-card__placeholder">
            <CategoryIcon name={cat.icon} />
          </span>
        )}
      </div>
      <div className="ro-item-card__meta">
        <VegMark veg={item.veg} />
        <span className="ro-item-card__price">{item.price}</span>
      </div>
      <h3>{item.name}</h3>
      {item.desc && <p>{item.desc}</p>}
    </Link>
  );
}
